// extracted by mini-css-extract-plugin
export var simpleHomeJumbotronSection = "SimpleHomeJumbotron-module--simpleHomeJumbotronSection--3V0N2";
export var backgroundImage = "SimpleHomeJumbotron-module--backgroundImage--twofC";
export var loginButton = "SimpleHomeJumbotron-module--loginButton--CmSq7";